import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import Responsive from '../assets/config/Responsive'
import CheckmarkIcon from '../assets/icons/JSX/CheckmarkIcon'
import RightArrow from '../assets/icons/JSX/RightArrow'
import Colors from '../assets/styles/Colors'
//
const Dropdown: React.FC<{
  title?: string
  placeholder?: string
  data?: string[]
  onChange: (value: any) => void
  defaultSelected?: string
  optionSomeElement?: any
  error?: boolean
}> = ({ title, placeholder, data, onChange, defaultSelected, optionSomeElement, error = false }) => {
  const [open, setOpen] = useState<boolean>(false)
  //
  const [selectedValue, setSelectedValue] = useState<string>()
  //
  const headRef = useRef(null)
  //
  const contentRef = useRef(null)
  //
  useEffect(() => {
    const closeDropdown = (e: any) => {
      const path = e.path || (e.composedPath && e.composedPath())
      if (path[0] !== headRef.current) {
        setOpen(false)
      }
      if (path[0] === contentRef.current) {
        setOpen(true)
      }
    }
    document.body.addEventListener('click', closeDropdown)
    return () => document.body.removeEventListener('click', closeDropdown)
  }, [])
  //
  //
  const onhandle = (event: any) => {
    setSelectedValue(event.target.innerText)
    onChange(event.target.innerText)
    //
    if (!selectedValue && event.target.innerText === selectedValue) {
      setSelectedValue('')
    }
  }
  // for default select
  useEffect(() => {
    if (data?.find((x) => x?.toString()?.toLowerCase() === defaultSelected?.toString()?.toLowerCase())) {
      setSelectedValue(defaultSelected?.toUpperCase())
      onChange(defaultSelected?.toUpperCase())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Wrapper>
      <Label>{title}</Label>
      <Head onClick={() => setOpen(!open)} $open={open} $error={error} ref={headRef}>
        <span>{selectedValue ? selectedValue : placeholder}</span>
        <ArrowIconStyle $open={open} />
      </Head>
      {open === true ? (
        <Content ref={contentRef}>
          <MobileContent>
            {data?.map((item, index) => (
              <ListItem key={index} onClick={onhandle}>
                <span>
                  {item} {optionSomeElement}
                </span>
                {selectedValue === item ? <CheckmarkIcon /> : null}
              </ListItem>
            ))}
          </MobileContent>
        </Content>
      ) : null}
    </Wrapper>
  )
}
//
//
// styles
const Label = styled.label`
  font-size: 14px;
  line-height: 16px;
  color: ${Colors.primaryGrey};
  padding-bottom: 12px;
`
const MobileContent = styled.div``
const ArrowIconStyle = styled(RightArrow)<{ $open: boolean }>`
  transform: ${({ $open }) => ($open === true ? 'rotate(270deg)' : 'rotate(90deg)')};
  color: ${({ $open }) => ($open === true ? Colors.primaryBlack : Colors.secondaryGrey)};
  width: 11px;
  height: 11px;
  pointer-events: none;
`
const ListItem = styled.div`
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 12px;
  border-radius: 4px;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  /* text-transform: uppercase; */
  /*  */
  &:hover {
    background-color: ${Colors.lightGrey};
    cursor: pointer;
  }
  /* svg  */
  svg {
    min-width: 16px;
    width: 16px;
    height: fit-content;
  }
`
const Content = styled.div`
  border: 1px solid ${Colors.primaryBlack};
  position: absolute;
  top: 100px;
  left: 0;
  z-index: 1;
  width: 100%;
  border-radius: 4px;
  background-color: ${Colors.white};
  padding: 12px;
  max-height: 226px;
  overflow-y: scroll;
`
const Head = styled.div<{ $open: boolean; $error: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  border-radius: 4px;
  /* -webkit-box-shadow: 0px 0px 15px 3px #88888811; 
    box-shadow: 0px 0px 15px 3px #88888811;  */
  border: 1px solid
    ${({ $open, $error }) =>
      $open === true
        ? Colors.primaryBlack
        : Colors.secondaryGrey
        ? $error === true
          ? Colors.primaryRed
          : Colors.secondaryGrey
        : Colors.secondaryGrey};
  cursor: pointer;
  user-select: none;
  padding-inline: 24px;
  background-color: ${Colors.white};

  span {
    pointer-events: none;
    font-size: 14px;
    color: ${Colors.primaryBlack};
    /* text-transform: uppercase; */
  }
`
const Wrapper = styled.div`
  /* width: 400px; */
  position: relative;
  margin-bottom: 25px;
  ${Responsive.mobile} {
    width: 100%;
  }
`
export default Dropdown
